import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams, HttpStatusCode } from '@angular/common/http';
import { TimeoutLimit } from '../../models/timeout-limit';
import { catchError, defer, map, throwError, timeout } from 'rxjs';
import { timeoutError } from '../../models/timeout-error';
import { Injectable, inject } from '@angular/core';
import { MemoResponse } from '../../dtos/response/discount-response/memo-response';
import { PromotionDetailsResponse } from '../../dtos/response/discount-response/promotion-details-response';

@Injectable()
export class DiscountService {
  private readonly http = inject(HttpClient);

  getDiscountCodeMemo(discountCode: string) {
    const options = {
      headers: new HttpHeaders({
        background: 'true',
      }),
    };
    return this.http.post<MemoResponse>('api/discount/memo', { discountCode }, options).pipe(
      timeout({
        each: TimeoutLimit.SHORT,
        with: () => defer(() => throwError(() => new HttpErrorResponse(timeoutError))),
      }),
      map((response) => response),
      catchError((err: HttpErrorResponse) => {
        if (err.status === HttpStatusCode.BadRequest) {
          return throwError(
            () =>
              new HttpErrorResponse({
                error: { discountCode, message: err.error?.discountCode },
                status: err.status,
                statusText: err.statusText,
              })
          );
        }
        return throwError(
          () =>
            new HttpErrorResponse({
              error: { discountCode, message: err.error },
              status: err.status,
              statusText: err.statusText,
            })
        );
      })
    );
  }
  getDiscountCodePromotionDetails(campaignId: number) {
    const queryParams = new HttpParams({ fromObject: { campaignId } });
    return this.http.get<PromotionDetailsResponse>('api/discount/promotion-details', { params: queryParams }).pipe(
      timeout({
        each: TimeoutLimit.SHORT,
        with: () => defer(() => throwError(() => new HttpErrorResponse(timeoutError))),
      }),
      map((response) => response),
      catchError((err: HttpErrorResponse) => {
        if (err.status === HttpStatusCode.BadRequest) {
          return throwError(
            () =>
              new HttpErrorResponse({
                error: { campaignId, message: err.error?.campaignId },
                status: err.status,
                statusText: err.statusText,
              })
          );
        }
        return throwError(
          () =>
            new HttpErrorResponse({
              error: { campaignId, message: err.error },
              status: err.status,
              statusText: err.statusText,
            })
        );
      })
    );
  }
}
